export enum AuthMethodType {
  Password = 'password',
  Shibboleth = 'shibboleth',
  Ldap = 'ldap',
  Ip = 'ip',
  X509 = 'x509',
  Oidc = 'oidc',
  Orcid = 'orcid'
}
